import React, { FC, useState, useEffect } from 'react';
import client from '../../../../graphql/client';
import { FeedbackCard } from './component';

export type FeedbackContainerProps = {
  session: any;
};

const FeedbackContainer: FC<FeedbackContainerProps> = (props) => {
  const { session } = props;
  const [feedbackArray, setFeedbackArray] = useState<any>(null);

  // TODO: This should be moved to Apollo Client State
  const currentFeedback = async (sessionId: string) => {
    const { items: feedback = {} } = await client.getFeedbackBySession({
      sessionId,
    });
    const { items: likes = {} } = await client.getLikesBySession({ sessionId });

    const combinedFeedback = feedback.map((feedback) => {
      const likeData = likes.find((like) => {
        return like.fanId === feedback.fanId;
      });
      feedback.likeValue = likeData ? likeData.likeValue : 0;
      return feedback;
    });
    setFeedbackArray(combinedFeedback);
  };

  useEffect(() => {
    currentFeedback(session.id);
  }, [session]);

  if (!feedbackArray) return null;
  return <FeedbackCard feedback={feedbackArray} />;
};

export default FeedbackContainer;
